<sn-drawer>
  <ng-container>
    <div class="debugPanel">
      <div class="mainDebugPanel">
        <div class="mainDebugPanelHeader">
          <h1>{{ 'debugPanel.title' | t }}</h1>
          <mat-icon class="closeIcon" (click)="closeDebugPanel()">close</mat-icon>
        </div>
        <div class="mainDebugPanelSelect" *ngIf="debugPanelItems.length > 0">
          <mat-select [(ngModel)]="selectedItemId">
            <mat-option *ngFor="let item of debugPanelItems" [value]="item.id">
              {{ item.label | t }}
            </mat-option>
          </mat-select>
        </div>
        <div class="mainDebugPanelContent">
          <ng-container #componentContainer></ng-container>
          <div *ngIf="debugPanelItems.length === 0" class="empty-state">
            {{ 'debugPanel.noDebugToolsRegistered' | t }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</sn-drawer>
